import { render } from "./GoldCoinBattle.vue?vue&type=template&id=2f815d5c&scoped=true"
import script from "./GoldCoinBattle.vue?vue&type=script&lang=js"
export * from "./GoldCoinBattle.vue?vue&type=script&lang=js"

import "./GoldCoinBattle.vue?vue&type=style&index=0&id=2f815d5c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f815d5c"]])

export default __exports__